import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Drifts children vertically as they pass through the viewport.
// speed > 0 lags behind the scroll (sinks), speed < 0 races ahead (rises).
export const ParallaxY = ({ children, speed = 0.5, className = "" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [speed * 56, speed * -56]);

  return (
    <motion.div ref={ref} style={{ y }} className={`relative will-change-transform ${className}`}>
      {children}
    </motion.div>
  );
};
